import React, { useState, useContext } from 'react';
import { Typography, Snackbar, Alert } from '@mui/material';
import { ThemeContext } from 'styled-components';
import UseHiddenState from './Hooks/UseHiddenState';

const ScratchOffText = ({
    hiddenText = 'Click to reveal',
    revealedText = '',
    copyText = 'Copied to clipboard!',
    sx = {},
    ...props
}) => {
    const { isHidden, show } = UseHiddenState(true);
    const [copySuccess, setCopySuccess] = useState(false);
    const theme = useContext(ThemeContext);

    const handleReveal = async () => {
        if (isHidden) {
            show();
        } else {
            // If already revealed, copy to clipboard
            await handleCopy();
        }
    };

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(revealedText);
            setCopySuccess(true);
            setTimeout(() => setCopySuccess(false), 2000);
        } catch (err) {
            console.error('Failed to copy text: ', err);
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = revealedText;
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
                setCopySuccess(true);
                setTimeout(() => setCopySuccess(false), 2000);
            } catch (fallbackErr) {
                console.error('Fallback copy failed: ', fallbackErr);
            }
            document.body.removeChild(textArea);
        }
    };

    return (
        <>
            <Typography
                variant="body2"
                sx={{
                    color: theme?.colors?.secondary || '#68ADB7',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    fontFamily: isHidden ? 'inherit' : 'monospace',
                    fontSize: isHidden ? 'inherit' : '0.9rem',
                    wordBreak: isHidden ? 'normal' : 'break-all',
                    textAlign: 'center',
                    userSelect: 'none',
                    '&:hover': {
                        color: theme?.colors?.brandTertiary || '#3DD4AD',
                        opacity: 0.8,
                    },
                    ...sx,
                }}
                onClick={handleReveal}
                {...props}
            >
                {isHidden ? hiddenText : revealedText}
            </Typography>

            {/* Copy success feedback */}
            <Snackbar
                open={copySuccess}
                autoHideDuration={2000}
                onClose={() => setCopySuccess(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert 
                    onClose={() => setCopySuccess(false)} 
                    severity="success" 
                    sx={{ width: '100%' }}
                >
                    {copyText}
                </Alert>
            </Snackbar>
        </>
    );
};

export default ScratchOffText;
